import { axiosInstance } from "@/services/axiosInstance";
import {
  FinancialSettings,
  Tax,
  CommissionMode,
  AuditLogResponse,
  EntityType,
} from "@/models/financialSettings.model";

export const createFinancialSettings = async (
  financialData: FinancialSettings
): Promise<FinancialSettings> => {
  const response = await axiosInstance.post(
    "/api/admin/financial-settings",
    financialData
  );

  return response.data;
};

export const updateFinancialSettings = async (
  id: string,
  financialData: Partial<FinancialSettings>
): Promise<FinancialSettings> => {
  const response = await axiosInstance.put(
    `/api/financial-settings/${id}`,
    financialData
  );
  return response.data;
};

export const getFinancialSettingsById = async (
  financialSettingsId?: string | null
): Promise<FinancialSettings | null> => {
  if (!financialSettingsId) return null;

  try {
    const response = await axiosInstance.get(
      `/api/financial-settings/${financialSettingsId}`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao obter o financialSettings:", error);
    throw error;
  }
};

export const deleteFinancialSettings = async (
  financialSettingsId: string | undefined
): Promise<any | null> => {
  if (!financialSettingsId) return null;

  try {
    const response = await axiosInstance.delete(
      `/api/financial-settings/${financialSettingsId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting financial settings:", error);
    throw error;
  }
};

export const getFinancialSettingsByCreditPromoterId = async (
  creditPromoterId?: string | null
): Promise<FinancialSettings | null> => {
  if (!creditPromoterId) return null;

  try {
    const response = await axiosInstance.get(
      `/api/financial-settings/credit-promoter/${creditPromoterId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erro ao obter o financialSettings por Credit Promoter ID:",
      error
    );
    throw error;
  }
};

export const fetchTaxes = async (): Promise<Tax[]> => {
  const response = await axiosInstance.get<Tax[]>("/api/taxes");
  return response.data;
};

export const fetchCommissionModes = async (): Promise<CommissionMode[]> => {
  const response = await axiosInstance.get<CommissionMode[]>(
    "/api/commission-modes"
  );
  return response.data;
};

export const fetchAuditLogsFinancialSettingsChanges = async (
  financialSettingsId: string
): Promise<AuditLogResponse[]> => {
  const response = await axiosInstance.get<{ data: AuditLogResponse[] }>(
    `/api/${financialSettingsId}/${EntityType.FINANCIAL_SETTINGS}/audit-history`
  );
  return response.data.data;
};

export const associateFinancialSettings = async (data: {
  financialSettingsId: string;
  creditType: string;
  creditPromoterId?: number;
  corbanId?: number;
  sellerId?: string;
}): Promise<any> => {
  // console.log("data", data);
  const response = await axiosInstance.post(
    "/api/financial-settings-associate",
    data
  );
  return response.data;
};
